export const config = {
  apiKey: "AIzaSyDmOxo7sXiVYbrE4WAL6TUof3L35DzGUec",
  authDomain: "art-portfolio-234210.firebaseapp.com",
  // authDomain: "photobanana.now.sh",
  databaseURL: "https://art-portfolio-234210.firebaseio.com",
  projectId: "art-portfolio-234210",
  storageBucket: "art-portfolio-234210.appspot.com",
  messagingSenderId: "930727068064"
};
